import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 50;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    landscape: {
      baseWidth: width * 1.08,
      baseHeight: height,
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-204),
        y: convertToPercentageY(2 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(110),
        y: convertToPercentageY(212 + yOffset),
        duration: 335,
      },
      {
        x: convertToPercentageX(103),
        y: convertToPercentageY(165 + yOffset),
        duration: 65,
      },
      {
        y: convertToPercentageY(196 + yOffset),
        duration: 70,
      },
      {
        y: convertToPercentageY(183 + yOffset),
        duration: 65,
      },
      {
        y: convertToPercentageY(191 + yOffset),
        duration: 70,
      },
      {
        wait: 300,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_4'));
          G.sfx.whoosh.play();
        },
      },
      {
        wait: 710,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_1'));
        },
      },
      {
        wait: 800,
        callback: () => {
          G.sfx.xylophone_positive_12.play();
        },
      },
      {
        y: convertToPercentageY(210 + yOffset),
        duration: 65,
      },
      {
        y: convertToPercentageY(78 + yOffset),
        duration: 130,
        callback: (object, config) => {
          const { parent } = config;
          parent.addChildAt(object, 0);
        },
      },
      {
        y: convertToPercentageY(201 + yOffset),
        duration: 170,
      },
      {
        y: convertToPercentageY(156 + yOffset),
        duration: 100,
      },
      {
        y: convertToPercentageY(177 + yOffset),
        duration: 65,
      },
      {
        y: convertToPercentageY(173 + yOffset),
        duration: 75,
      },
      {
        wait: 140,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_6'));
        },
      },
      {
        wait: 430,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_1'));
        },
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        alpha: 0,
        x: convertToPercentageX(104),
        y: convertToPercentageY(268),
        scale: 0.3,
      },
      {
        wait: 990,
      },
      {
        alpha: 1,
      },
      {
        angle: 179,
        x: convertToPercentageX(361),
        y: convertToPercentageY(855),
        scale: 1.25,
        duration: 500,
      },
      {
        alpha: 0.98,
        angle: -124,
        x: convertToPercentageX(352),
        y: convertToPercentageY(843),
        scale: 1.3,
        duration: 75,
      },
      {
        alpha: 0.38,
        angle: -45,
        x: convertToPercentageX(340),
        y: convertToPercentageY(826),
        scale: 1.37,
        duration: 100,
      },
      {
        alpha: 0,
        duration: 70,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        angle: -71,
        x: convertToPercentageX(326),
        y: convertToPercentageY(791),
        scale: 2.88,
      },
      {
        wait: 1710,
      },
      {
        alpha: 1,
        angle: -119,
        x: convertToPercentageX(332),
        y: convertToPercentageY(605),
        scale: 3.6,
        duration: 165,
      },
      {
        angle: -148,
        x: convertToPercentageX(336),
        y: convertToPercentageY(496),
        scale: 4,
        duration: 100,
        callback: () => {
          G.sb('corruptWindow').dispatch();
        },
      },
      {
        angle: -176,
        x: convertToPercentageX(332),
        y: convertToPercentageY(321),
        scale: 3.74,
        duration: 135,
      },
      {
        alpha: 0,
        angle: -120,
        x: convertToPercentageX(326),
        y: convertToPercentageY(53),
        scale: 3.23,
        duration: 200,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(115),
        y: convertToPercentageY(844),
      },
      {
        wait: 2100,
      },
      {
        alpha: 1,
        angle: 40,
        x: convertToPercentageX(117),
        y: convertToPercentageY(651),
        scale: 1.18,
        duration: 135,
      },
      {
        angle: 85,
        x: convertToPercentageX(120),
        y: convertToPercentageY(431),
        scale: 1.38,
        duration: 165,
      },
      {
        alpha: 0,
        angle: 160,
        x: convertToPercentageX(125),
        y: convertToPercentageY(66),
        scale: 1.73,
        duration: 270,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(529),
        y: convertToPercentageY(566),
      },
      {
        wait: 2100,
      },
      {
        alpha: 1,
        angle: 43,
        x: convertToPercentageX(524),
        y: convertToPercentageY(457),
        scale: 1.16,
        duration: 130,
      },
      {
        angle: 105,
        x: convertToPercentageX(516),
        y: convertToPercentageY(302),
        scale: 1.39,
        duration: 200,
      },
      {
        alpha: 0,
        angle: 175,
        x: convertToPercentageX(507),
        y: convertToPercentageY(126),
        scale: 1.65,
        duration: 235,
      },
    ],
  },
];
